import { render, staticRenderFns } from "./ExpenseTag.vue?vue&type=template&id=4fe6e08a&"
import script from "./ExpenseTag.vue?vue&type=script&lang=js&"
export * from "./ExpenseTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports